import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { Text } from '@hhgtech/hhg-components/mantine'
import { ActionIcon, rem } from '@mantine/core'

import { CardArticleAuthor } from './CardArticleAuthor'

export const StyledCardArticleBookmark = styled(ActionIcon)<any>`
  font-size: ${rem(24)};
  &.saved {
    color: ${theme.colors.green600};
    stroke: ${theme.colors.green600};
  }
`

export const StyledCardArticleAuthor = styled(CardArticleAuthor)`
  flex: 1;
  min-width: 0;
`

export const StyledCardArticleFooter = styled.div`
  margin-top: ${rem(16)};
  display: flex;
  gap: ${rem(8)};
  align-items: center;
  width: 100%;

  ${MediaQueries.tdDown} {
    & {
      margin-top: ${rem(8)};
    }
  }
`

export const StyledCardArticleExcerpt = styled.p``

export const StyledCardArticleTitle = styled(Text)`
  margin-bottom: 0;
`

export const StyledCardArticleTitleLink = styled.a`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
`

export const StyledCardArticleCategory = styled(Text)``

export const StyledCardArticleContent = styled.div`
  padding-top: ${rem(16)};
  display: flex;
  flex-direction: column;
  gap: 4;
`

export const StyledCardArticleImageWrap = styled.div`
  .cardArticleImageRatio {
    border-radius: ${rem(8)};
    overflow: hidden;
  }
`

export const StyledCardArticle = styled.div`
  &.cardArticle__horizontal {
    display: grid;
    grid-template-columns: 1fr ${rem(168)};
    column-gap: ${rem(16)};

    ${StyledCardArticleImageWrap} {
      grid-column: 2;
      grid-row: 1/3;
    }

    ${StyledCardArticleContent} {
      padding-top: 0;
      grid-column: 1;
      grid-row: 1;
    }

    ${StyledCardArticleFooter} {
      grid-column: 1;
      grid-row: 2;
      margin-top: ${rem(8)};
    }

    ${StyledCardArticleCategory} {
      margin-bottom: ${rem(8)};
    }
  }

  &.cardArticle__horizontalFooter {
    display: flex;
    gap: ${rem(12)};
    flex-wrap: wrap;

    ${StyledCardArticleImageWrap} {
      order: 2;
      width: ${rem(80)};
      .cardArticleImageRatio {
        &:before {
          padding-bottom: 100%;
        }
      }
    }

    ${StyledCardArticleContent} {
      order: 1;
      flex: 1;
      min-width: 0;
      padding-top: 0;
    }

    ${StyledCardArticleFooter} {
      order: 3;
      width: 100%;
      margin-top: 0;
    }

    ${StyledCardArticleCategory} {
      margin-bottom: ${rem(4)};
    }

    ${StyledCardArticleTitle} {
      font-size: ${rem(18)};
      line-height: ${rem(26)};
      letter-spacing: 0;
    }
  }

  ${MediaQueries.smbDown} {
    &.cardArticle__horizontal {
      display: flex;
      flex-wrap: wrap;

      ${StyledCardArticleImageWrap} {
        order: 2;
        width: ${rem(80)};
        .cardArticleImageRatio {
          &:before {
            padding-bottom: 100%;
          }
        }
      }

      ${StyledCardArticleContent} {
        order: 1;
        flex: 1;
        min-width: 0;
      }

      ${StyledCardArticleFooter} {
        order: 3;
        width: 100%;
      }

      ${StyledCardArticleCategory} {
        margin-bottom: ${rem(4)};
      }
    }
  }
`
